import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    exportsTransferencias: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).add(30, 'days').format('YYYY-MM-DD'),
    sortByDescending: true,
};

const mutations = {
    updateField,

    'INICIALIZAR_EXPORTS_TRANSFERENCIAS' (state) {
        state.exportsTransferencias = [];
    },
    'SET_EXPORTS_TRANSFERENCIAS' (state, exportsTransferencias) {
        state.exportsTransferencias = exportsTransferencias;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const getters = {
    getField,
};

const actions = {
    getExportsTransferencias ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_EXPORTS_TRANSFERENCIAS');

            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                + '&pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;
               
            if (!(/true/i).test(state.sortByDescending)) {
                queryString += '&sortByDescending=false';
            }
            
            apiAxios.get('edi/export/transferencias' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_EXPORTS_TRANSFERENCIAS', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    delete ( {}, exportId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`edi/export/transferencias/${exportId}/delete`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}